/* eslint-disable */

import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { forgotPassword } from "../../Services/authService";
import Loader from "../Main/Loader";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] =
        useState(false);

    const navigate = useNavigate()
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const body = {
            email,
        };

        try {
            const response = await forgotPassword(body);

            if (response.code === 200) {
                console.log("forgotPassword", response);
                localStorage.setItem("userEmail", email)
                toast.success(response.message);
                navigate("/reset-password")
                setEmail("");
            } else if (response.code === 403) {
                toast.error(response.message);
            } else if (response.errors) {
                for (const [key, value] of Object.entries(
                    response.errors
                )) {
                    toast.error(value);
                }
            } else {
                toast.error("Something went wrong.");
            }
        } catch (error) {
            console.log(
                "Error in forgot password",
                error
            );
            toast.error(
                "An error occurred. Please try again."
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <section className='mt-5'>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="">
                            <h3 className='text-center fw-bold'>Popgop Referral System</h3>
                            <div className="container py-5">
                                <div className="row justify-content-center">
                                    <div className="col-lg-6">
                                        <div className="card border-0 shadow p-3 ">
                                            <h5 className="text-center">
                                                Forgot Password
                                            </h5>
                                            <p className="text-center small">
                                                Enter your email to reset your password
                                            </p>
                                            <Form onSubmit={handleSubmit}>
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="formBasicEmail">
                                                    <Form.Label>Email address</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter email"
                                                        value={email}
                                                        onChange={(e) =>
                                                            setEmail(e.target.value)
                                                        }
                                                        required
                                                    />
                                                </Form.Group>
                                                <Button
                                                    variant="primary"
                                                    type="submit"
                                                    className="w-100"
                                                    disabled={isLoading}>
                                                    {isLoading ? (
                                                        <Loader />
                                                    ) : (
                                                        "Send Reset Link"
                                                    )}
                                                </Button>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );
};

export default ForgotPassword;